import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "db6a7e4e-5ebe-48fd-97a4-020ab04c7340", // EMS - Local Dev client ID
    authority: "https://login.microsoftonline.com/78cb144c-fd63-4b9f-b0d1-c6c27fc21e66", // EMS - Local Dev tenant ID
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `${window.location.origin}/login`, // Redirect to login page after logout
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored, more secure than localStorage, cleared when tab closes
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"], // Add any additional scopes needed for your application
  prompt: "select_account", // Always show the Microsoft account picker instead of silently reusing a cached session
};